import React from 'react'
import { connect } from 'react-redux'

import FontAwesomeIcon from '@fortawesome/react-fontawesome'

import {
  userLocationSelector,
} from '../reducers/userLocationReducer'

import styles from './UserLocationMessage.module.css'




export default connect(
  state => {
    return {
      userLocation: userLocationSelector(state)
    }
  }
)(UserLocationMessageView)


function UserLocationMessageView({userLocation}) {

  if (userLocation.isFetching)
    return (
      <span className={styles.fetching}>
        <FontAwesomeIcon icon={['fal','location-arrow']} />
        &nbsp; Searching for your location...
      </span>
    )
  else if (userLocation.error)
    return (
      <span className={styles.error}>
        <FontAwesomeIcon icon={['fal','exclamation-circle']} />
        &nbsp; Couldn't find your location
      </span>
    )
  else
    return null

}



// WEBPACK FOOTER //
// ./src/components/UserLocationMessage.js